import axios from "axios";
import { ApiKey, liveURL } from "../../const/constants";

const MAIN_URL = `${liveURL}/userDatabase`;
const REGISTER_USER = `${MAIN_URL}/registerUser`;
const FIELDS_URL = `${MAIN_URL}/fields`;

const VERIFY_URL = `${MAIN_URL}/verifyKey`;

export async function verifyKey(userKey) {
  try {
    const response = await axios.post(
      VERIFY_URL,
      { userKey: userKey },
      {
        headers: {
          apikey: ApiKey,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Key verification failed:", error.response?.data || error);
    throw error;
  }
}

export async function getFields() {
  try {
    const response = await axios.get(FIELDS_URL);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch UDF fields:", error.response?.data || error);
    throw error;
  }
}

export async function registerUser(formData) {
  try {
    const response = await axios.post(REGISTER_USER, formData, {
      headers: {
        apikey: ApiKey,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to Register User:", error.response?.data || error);
    throw error;
  }
}
